module.exports = __webpack_public_path__ + "videos/hero_en.ad77a61.mp4";